var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('u-field',{attrs:{"vid":"name","vname":_vm.$t('_.name').toLowerCase(),"label":_vm.$t('_.name')}},[_c('b-input',{attrs:{"value":_vm.value,"disabled":_vm.isDisabled,"placeholder":_vm.$t('_.name'),"name":"name"},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }